module.exports = __webpack_public_path__ + "img/magento-code-review.35151f85.webp";